import dayjs from 'lib/dayjs';

export const copyToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};

export const formateTime = (time) => {
  return dayjs(time, 'HH:mm').format('h:mm A');
};

export const customDayjs = dayjs;
